import React, {Component} from 'react';

class Gif extends Component {

  getBackgroundImagePath(filename) {
    return `${window.public_url}/images/scenes/animations/${filename}`
  }

  render() {

    const { image } = this.props;

    return (<div className="gif">
      <img alt="gif" src={this.getBackgroundImagePath(image)} />
    </div>)
  }
}


export default Gif;



// WEBPACK FOOTER //
// ./src/components/Gif.jsx